import { MarkSpec } from 'prosemirror-model'

interface Attrs {
  href: string
}

export const link: MarkSpec = {
  attrs: {
    href: { default: '' },
  },
  inclusive: false,
  parseDOM: [
    {
      tag: 'a[href]',
      getAttrs: (dom: HTMLElement): Attrs => {
        const element = dom as HTMLOListElement;
        return {
          href: element.getAttribute('href') as string,
        }
      },
    },
  ],
  toDOM(mark) {
    const { href } = mark.attrs as Attrs

    return ['a', {
        href,
        target: "_blank",
        rel: "noopener noreferrer"
    }, 0]
  },
}
